import { render } from "./IntroducerProfitReport.vue?vue&type=template&id=56b46443"
const script = {}

import exportComponent from "/Users/hank/winho/gx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__